/**
 * Вернет объект с короткой и полной датой/временем.
 * short - краткий формат
 * full - полная дата и время в формате dd.MM.yyyy hh:mm
 */
export function formatDateTime(utc: string, removeYear: boolean = false) {
    const date = new Date(utc);

    if (!isValidDate(date)) {
        return { short: '', full: '' };
    }

    const month = date.getMonth() + 1;

    const dd = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    const MM = month < 10 ? '0' + month : month;
    const hh = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    const mm = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();

    const full = `${dd}.${MM}.${date.getFullYear()} ${hh}:${mm}`;

    let short: string;
    if (isToday(date)) {
        short = `${hh}:${mm}`;
    } else if (removeYear || isThisYear(date)) {
        short = `${hh}:${mm}, ${dd}.${MM}`;
    } else {
        // Для прошлогодних видео время не так важно
        short = `${dd}.${MM}.${date.getFullYear()}`;
    }

    return { short, full };
}

function isValidDate(d: unknown) {
    return d instanceof Date && isFinite(d.getTime());
}

function isThisYear(d: Date) {
    return d.getFullYear() === new Date().getFullYear();
}

function isToday(d: Date) {
    const now = new Date();
    return (
        d.getDate() === now.getDate() &&
        d.getMonth() === now.getMonth() &&
        d.getFullYear() === now.getFullYear()
    );
}
